export default __webpack_public_path__ + "static/media/rechercher.9c6cc3cb.svg";